/** @type {import('@vue/compat').ComponentOptions} */
export default {
  data: {
    data: [],
    index: '',
    list: [],
    paged: 0,
    pages: 0,
    locked: false,
    loadingMore: false,
    messageContent: '',
    selectedImage: null,
    imageId: 0,
    paramValue: '',
    timeThreshold: 600,
    scrollHeightBeforeLoad: 0,
    noMore: false,
    showEmoji: false,
    emoji: [],
    clientWidth: qkClientWidth,
    loaded: false,
  },
  created() {
    this.paramValue = qkGetQueryVariable('type') || qkGetQueryVariable('whisper');
    this.updateClientWidth();
  },
  mounted() {
    if (!qktoken) return this.$createModal('login');

    this.updateClientWidth();

    (/iphone|ipod|ipad/i.test(navigator.appVersion)) && document.addEventListener(
      'blur',
      (event) => {
        if (
          document.documentElement.offsetHeight <= document.documentElement.clientHeight
          && ['input', 'textarea'].includes(event.target.localName)
        ) {
          document.body.scrollIntoView();
        }
      },
      true,
    );

    this.$http.post(`${qk_rest_url}getContactList`).then((res) => {
      this.data = res.data;
      const index = this.data.findIndex(
        (item) => item.type === this.paramValue || item.from?.id === this.paramValue,
      );
      if (index !== -1) {
        this.indexChange(index);
      } else if (!isNaN(this.paramValue) && this.paramValue && qkGetQueryVariable('whisper')) {
        this.$http.post(`${qk_rest_url}getContact`, { user_id: this.paramValue }).then((contactRes) => {
          this.data.unshift(contactRes.data);
          this.index = 0;
        }).catch((err) => {
          this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
        });
      }
    }).catch((err) => {
      this.$message({ message: qkGetApiError(err, '操作失败'), type: 'warning' });
    }).finally(() => {
      this.loaded = true;
    });

    window.addEventListener('resize', () => {
      this.updateClientWidth();
    });
  },
  methods: {
    updateClientWidth() {
      this.clientWidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth
        || 0;
    },
    sendMessage() {
      if (this.messageContent.trim() === '' && !this.selectedImage) return;

      const userAvatarElement = document.querySelector('.user-avatar img');
      const userAvatarUrl = userAvatarElement.getAttribute('src');

      function addZero(num) {
        return num < 10 ? `0${num}` : num;
      }

      const now = new Date();
      const time = `${addZero(now.getHours())}:${addZero(now.getMinutes())}`;

      const data = {
        from: { avatar: userAvatarUrl },
        content: this.messageContent,
        is_self: true,
        is_read: false,
        date: time,
        mark: {},
      };

      if (this.emoji.length) {
        for (let i = 0; i < this.emoji.length; i++) {
          const emojiName = Object.keys(this.emoji[i])[0];
          const emojiIcon = this.emoji[i][emojiName];
          const regex = new RegExp(`\\[${emojiName}\\]`, 'g');
          data.content = data.content.replace(regex, emojiIcon);
        }
      }

      if (this.selectedImage) {
        data.mark.url = this.selectedImage;
        data.mark.type = 'image';
        this.messageContent = '[图片]';
      }

      if (this.index > 0) {
        const item = this.data[this.index];
        item.content = this.messageContent;
        item.date = time;
        this.data.splice(this.index, 1);
        this.data.unshift(item);
        this.index = 0;
      } else {
        this.data[this.index].content = this.messageContent;
        this.data[this.index].date = time;
      }

      this.list.push(data);

      this.$nextTick(() => {
        qkUpdateLazyLoad();
      });

      this.scrollToBottom();

      this.$http.post(`${qk_rest_url}sendMessage`, {
        user_id: this.data[this.index].from.id,
        content: this.messageContent,
        image_id: this.imageId,
      }).catch((err) => {
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'warning' });
      });

      this.messageContent = '';
      this.selectedImage = null;
      this.imageId = 0;
    },
    handleScroll() {
      const messageList = this.$refs.messageList;
      if (
        this.data[this.index].type === 'chat'
        && messageList.scrollTop > 0
        && messageList.scrollTop < 10
        && !this.loadingMore
      ) {
        messageList.removeEventListener('scroll', this.handleScroll);
        this.loadMore();
      } else if (
        this.data[this.index].type !== 'chat'
        && (messageList.scrollTop + messageList.offsetHeight) >= (messageList.scrollHeight - 300)
        && !this.loadingMore
      ) {
        messageList.removeEventListener('scroll', this.handleScroll);
        this.loadMore();
      }
    },
    loadMore() {
      this.scrollHeightBeforeLoad = this.$refs.messageList.scrollHeight;
      this.loadingMore = true;
      this.getMessageList();
    },
    indexChange(index) {
      if (index === this.index) return;
      this.list = [];
      this.index = index;
      this.paged = 0;
      this.pages = 0;
      this.loadingMore = false;
      this.noMore = false;
      this.locked = false;

      if (this.data[this.index].from.id) {
        qkSetQueryParams({ whisper: this.data[this.index].from.id });
      } else {
        qkSetQueryParams({ type: this.data[this.index].type });
      }

      this.$nextTick(() => {
        this.$refs.messageList.removeEventListener('scroll', this.handleScroll);
      });

      this.getMessageList();
    },
    backClick() {
      this.list = [];
      this.index = '';
      this.paged = 0;
      this.pages = 0;
      this.loadingMore = false;
      this.noMore = false;
      this.locked = false;
      const url = new URL(window.location.href);
      url.search = '';
      history.pushState(null, '', url);
    },
    getMessageList() {
      this.paged += 1;
      if (this.paged > this.pages && this.paged !== 1) return;
      this.locked = true;

      const data = {
        type: this.data[this.index].type,
        id: this.data[this.index].id,
        sender_id: this.data[this.index].type === 'chat' ? this.data[this.index].from.id : 0,
        unread: this.data[this.index].unread,
        paged: this.paged,
      };

      this.$http.post(`${qk_rest_url}getMessageList`, data).then((res) => {
        if (
          this.data[this.index].type === 'chat'
          || this.data[this.index].type === 'vip'
          || this.data[this.index].type === 'circle'
          || this.data[this.index].type === 'distribution'
        ) {
          this.list.unshift(...this.filteredList(res.data.data));
        } else {
          this.list.push(...res.data.data);
        }

        if (
          this.paged > 1
          && res.data.data.length > 0
          && (
            this.data[this.index].type === 'chat'
            || this.data[this.index].type === 'vip'
            || this.data[this.index].type === 'circle'
            || this.data[this.index].type === 'distribution'
          )
        ) {
          this.$nextTick(() => {
            this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight - this.scrollHeightBeforeLoad;
          });
        }

        this.pages = res.data.pages;
        this.locked = false;
        this.loadingMore = false;
        if (this.pages <= this.paged) {
          this.noMore = true;
        } else {
          this.$nextTick(() => {
            this.$refs.messageList.addEventListener('scroll', this.handleScroll);
          });
        }

        if (
          this.paged === 1
          && (
            this.data[this.index].type === 'chat'
            || this.data[this.index].type === 'vip'
            || this.data[this.index].type === 'circle'
            || this.data[this.index].type === 'distribution'
          )
        ) {
          addLoadEvent(this.scrollToBottom());
        }

        this.$nextTick(() => {
          qkUpdateLazyLoad();
        });

        imgFancybox('.img-msg img');
      }).catch((err) => {
        this.locked = false;
        this.loadingMore = false;
        if (this.paged > 1) {
          this.paged -= 1;
        }
        this.$message({ message: qkGetApiError(err, '加载消息失败'), type: 'warning' });
      });
    },
    handleFileUpload(event) {
      if (event.target.files.length <= 0) return;
      if (this.locked) return;
      this.locked = true;
      const file = event.target.files[0];
      event.target.value = '';

      if (file.size <= 1 * 1024000) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('post_id', 1);
        formData.append('type', 'post');

        this.$http.post(`${qk_rest_url}fileUpload`, formData).then((res) => {
          this.imageId = res.data.id;
          this.selectedImage = res.data.url;
          this.locked = false;
          this.sendMessage();
        }).catch((err) => {
          const msg = qkGetApiError(err, '上传失败') || '上传失败，请重新上传';
          this.$message({ message: msg, type: 'warning' });
          this.selectedImage = null;
          this.imageId = 0;
          this.locked = false;
        });
      } else {
        this.$message({ message: `文件[${file.name}]大小超过限制，最大1M，请重新选择`, type: 'error' });
        this.locked = false;
      }
    },
    handleClick(emoji) {
      this.messageContent += `[${emoji.name}]`;
      this.emoji.push({ [emoji.name]: `<img class="emoticon-image ${emoji.size}" src="${emoji.icon}">` });
      this.$refs.textarea.focus();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const messageList = document.querySelector('.message-list');
        messageList.scrollTop = messageList.scrollHeight;
      });
    },
    filteredList(list) {
      const filteredList = [];
      let prevTime = null;

      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        const currentTime = item.time;

        if (!prevTime || currentTime - prevTime > this.timeThreshold) {
          item.showDate = true;
        } else {
          item.showDate = false;
        }

        filteredList.push(item);
        prevTime = currentTime;
      }

      return filteredList;
    },
    containerStyle(mark) {
      const maxWidth = 320;
      const maxHeight = 320;
      const scale = Math.min(maxWidth / mark.width, maxHeight / mark.height);
      return {
        width: `${mark.width * scale}px`,
        height: `${mark.height * scale}px`,
      };
    },
  },
};
